import React, { useState } from "react";

function Header() {
  return (
    <div>
      <h1>TARAN LEU</h1>
    </div>
  );
}

export default Header;
